import { CmmStatus } from "../../../../enums/cmmStatus";

export const shouldOpenCmmModal = (cmmStatus: string) => {
  if (cmmStatus === CmmStatus.INVALID_KEY) {
    return false;
  }
  if (cmmStatus === CmmStatus.IN_PROGRESS) {
    return false;
  }
  if (cmmStatus === CmmStatus.COMPLETED) {
    return true;
  }
  if (cmmStatus === CmmStatus.FAILED) {
    return true;
  }
  if (cmmStatus === CmmStatus.ADDITIONAL_QA) {
    return true;
  }
  if (cmmStatus === CmmStatus.STP_FAILED) {
    return true;
  }
  if (cmmStatus === CmmStatus.EXPIRED) {
    return true;
  }
  if (cmmStatus === CmmStatus.PATIENT_MISMATCH) {
    return true;
  }
  return false;
};
